module.exports = __webpack_public_path__ + "static/media/Brands_20.5021243a.png";